import slice from './conversationThreadsSlice';

export const {
  populateThreads,
  addThread,
  updateThread,
  resolveThread,
  setActiveThread,
  toggleCommentMode,
  disableCommenting,
  resetConversationThreads,
} = slice.actions;

export default slice.reducer;
